define('components/overlay',[
    'jquery'
], function($) {

   $.extend(companyInfo.handlers, {

        'in-overlay': function(e) {
            e.preventDefault();
            var url = this.href;
            var panel = $(this).closest('.panel');
            var panelHeading = $(this).closest('h2');
            var panelContent = panel.find('.panel-content');
            var openOverlay = function() {
                // Create an edit panel to show the new content in
                var panelEditing = $('<div class="panel-editing loading"></div>');
                panelContent.prepend(panelEditing);
                var size = companyInfo.size();
                if (size && size <= 2) {
                    panelHeading.addClass('open');
                }
                // Tell the server to return an HTML fragment instead of a full page if possible. Either way, we'll
                // search for a node matching targetSelector
                if (url.indexOf('?') === -1) {
                    url = url + '?partial=true';
                } else {
                    url = url + '&partial=true';
                }

                $.get(url).always(function(data) {
                    data = data.responseText || data;
                    var html = $('<div>').append($.parseHTML(data)).find('.panel-content > *');
                    if ( !html.length ) {
                        html = data;
                    }
                    panelEditing.html(html);
                    require(['components/decorator'], function(decorator) {
                        decorator.run(panelEditing);
                        var height = panelEditing.find('> *').outerHeight(true) + 20;
                        panelEditing.removeClass('loading').height(height);
                        setTimeout(function() {
                            panelEditing.height('auto');
                            setTimeout(function() {
                                panelEditing.find('input:first').focus();
                            }, 10);
                        }, companyInfo.transitions);
                    });
                });
            };
            if (panelContent.find('.panel-editing').length) {
                require(['components/overlay'], function(overlay) {
                    overlay.hide({
                        panel: panel,
                        callback: openOverlay
                    });
                });
            } else {
                openOverlay();
            }
        },

        'cancel': function(e) {
            if ($(this).closest('.panel-editing').length) {
                e.preventDefault();
                var panel = $(this).closest('.panel');
                require(['components/overlay'], function(overlay) {
                    overlay.hide({panel: panel});
                });
            }
        }

    });

    return {
        hide: function(options) {
            options = options || {
                panel: false,
                callback: false
            };
            if (!options.panel) {
                return;
            }
            var panelEditing = options.panel.find('.panel-editing');
            panelEditing.height(panelEditing.height());
            setTimeout(function() {
                panelEditing.height(0);
                options.panel.attr('tabindex', -1).focus();
                setTimeout(function() {
                    panelEditing.remove();
                    if (options.callback) {
                        options.callback();
                    }
                }, companyInfo.transitions);
            }, 10);

        }
    };

});
